module.exports = __webpack_public_path__ + "static/media/appIcon.76e03b8f.png";